<script setup lang="ts">
import DarkModeSwitcher from "../../components/DarkModeSwitcher";
import LoadingIcon from "../../base-components/LoadingIcon";
import Lucide from "../../base-components/Lucide";
import { onBeforeMount, ref } from "vue";
import { oAuthGoogleGuardarTokenFunction } from "../../services/cloudFunctions/oAuthGoogleGuardarToken";

const ambiente = import.meta.env.VITE_ENV_NOMBRE;
const cargando = ref(false);
const exito = ref(true);
const mensaje = ref("");
const countdown = ref(3);

onBeforeMount(async () => {
  const currentUrl = new URL(window.location.href);
  const params = new URLSearchParams(currentUrl.search);
  const codeString = params.get("code");

  const result = await oAuthGoogleGuardarTokenFunction({
    redirectURL: window.location.origin,
    code: codeString ?? ""
  });
  if (result.exito) {
    exito.value = true;
    cargando.value = false;

    const interval = setInterval(() => {
      countdown.value--;
      if (countdown.value === 0) {
        clearInterval(interval);
        window.close();
      }
    }, 1000);
  } else {
    exito.value = false;
    cargando.value = false;
    mensaje.value = result.errorMsg;
  }
});
</script>

<template>
  <div
    :class="[
      '-m-3 sm:-mx-8 p-3 sm:px-8 relative h-screen lg:overflow-hidden bg-primary xl:bg-white dark:bg-darkmode-800 xl:dark:bg-darkmode-600',
      'before:hidden before:xl:block before:content-[\'\'] before:w-[57%] before:-mt-[28%] before:-mb-[16%] before:-ml-[13%] before:absolute before:inset-y-0 before:left-0 before:transform before:rotate-[-4.5deg] before:bg-primary/20 before:rounded-[100%] before:dark:bg-darkmode-400',
      'after:hidden after:xl:block after:content-[\'\'] after:w-[57%] after:-mt-[20%] after:-mb-[13%] after:-ml-[13%] after:absolute after:inset-y-0 after:left-0 after:transform after:rotate-[-4.5deg] after:bg-primary after:rounded-[100%] after:dark:bg-darkmode-700'
    ]"
  >
    <!-- <DarkModeSwitcher /> -->
    <div class="container relative z-10 sm:px-10">
      <div class="block grid-cols-2 gap-4 xl:grid">
        <!-- BEGIN: Login Info -->
        <div class="flex-col hidden min-h-screen xl:flex">
          <div class="my-auto">
            <img
              alt="Fixed"
              class="w-1/2 -mt-16 -intro-x"
              src="/logo_nuevo_blanco_x_color.png"
            />
            <div
              class="mt-10 text-4xl font-medium leading-tight text-white -intro-x"
            >
              Tu solución a la<br />
              Facturación electrónica.
              <template v-if="ambiente != 'Produccion'">
                <p class="mt-5 text-danger">Ambiente {{ ambiente }}</p>
              </template>
            </div>
          </div>
        </div>
        <!-- END: Login Info -->
        <!-- BEGIN: Login Form -->
        <div
          class="flex h-screen py-5 my-10 xl:h-auto xl:my-10 overflow-y-auto max-h-[80vh]"
        >
          <div
            class="w-full px-5 py-8 mx-auto my-auto bg-white rounded-md shadow-md xl:ml-20 dark:bg-darkmode-600 xl:bg-transparent sm:px-8 xl:p-0 xl:shadow-none sm:w-3/4 lg:w-2/4 xl:w-auto"
          >
            <div v-if="cargando">
              <div
                class="flex flex-col items-center justify-end col-span-6 sm:col-span-3 xl:col-span-2"
              >
                <LoadingIcon icon="oval" class="w-8 h-8" />
              </div>
            </div>
            <div v-else>
              <div v-if="exito">
                <div class="p-5 text-center">
                  <Lucide
                    icon="CheckCircle"
                    class="w-16 h-16 mx-auto mt-3 text-success"
                  />
                  <h2 class="text-2xl mt-5 font-bold text-center intro-x">
                    Datos guardados con éxito
                  </h2>
                  <h2 class="text-xl mt-5 font-bold text-center intro-x">
                    Esta pantalla se cerrara en {{ countdown }} segúndos...
                  </h2>
                </div>
              </div>
              <div v-else>
                <h2 class="text-2xl font-bold text-center mb-5">
                  Error guardando datos
                </h2>
                <p>{{ mensaje }}</p>
                <p>
                  Si antes intentaste vincular la cuenta, quizás el proceso no
                  se pudo completar con éxito y por eso ocurrío este error.
                </p>
                <p>
                  Puedes eliminar la cuenta de Fixed y comenzar el proceso de 0,
                  para esto debes ingresar a: Ir a tu cuenta de Google -> Mi
                  cuenta -> Datos y privacidad -> Aplicaciones y servicios de
                  terceros, y eliminar a Fixed
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- END: Login Form -->
      </div>
    </div>
  </div>
</template>
